module.exports = __webpack_public_path__ + "img/remote-work-visit.2c314aba.svg";